var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Center, useSlotRecipe } from "@chakra-ui/react";
import { useLayoutEffect, useRef } from "react";
import { Header } from "@/components/Header";
import { SearchFormChildren } from "@/components/SearchForm";
import { TopBanner } from "@/components/TopBanner";
import { SearchForm } from "@/components/cortex";
function useTopHeight() {
    var topRef = useRef(null);
    useLayoutEffect(function () {
        var node = topRef.current;
        var ownerWindow = node === null || node === void 0 ? void 0 : node.ownerDocument.defaultView;
        if (!node || !ownerWindow)
            return;
        var previousHeight;
        var updateTopHeight = function () {
            var height = node.clientHeight;
            if (height === previousHeight)
                return;
            previousHeight = height;
            node.ownerDocument.documentElement.style.setProperty("--top-height", "".concat(height, "px"));
        };
        updateTopHeight();
        var resizeObserver = new ownerWindow.ResizeObserver(updateTopHeight);
        resizeObserver.observe(node);
        return function () { return resizeObserver.disconnect(); };
    }, []);
    return topRef;
}
export function Top(_a) {
    var modules = _a.modules, datePostedOptions = _a.datePostedOptions;
    var recipe = useSlotRecipe({ key: "Top" });
    var recipeProps = recipe.splitVariantProps({})[0];
    var styles = recipe(recipeProps);
    var topRef = useTopHeight();
    return (_jsxs(Box, __assign({ ref: topRef, css: styles.stickyTop }, { children: [modules.topBanner && _jsx(TopBanner, {}), modules.header && _jsx(Header, {}), _jsx(Center, __assign({ css: styles.searchFormBackgroundWrapper }, { children: _jsx(Box, __assign({ css: styles.searchFormWrapper }, { children: _jsx(SearchForm, { children: _jsx(SearchFormChildren, { modules: modules, datePostedOptions: datePostedOptions }) }) })) }))] })));
}
